import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import logo from '@root/assets/logo.png';
import Dropdown from './Dropdown';

type NavItem = {
    name: string;
    pageId: string;
    dropdown?: { name: string; pageId: string; }[];
};

const navItems: NavItem[] = [
  { name: 'WHO WE ARE', pageId: 'who-we-are' },
  { name: 'WHAT WE DO', pageId: 'about' },
  { name: 'STORES', pageId: 'stores' },
  { name: 'CAREERS', pageId: 'careers' },
];

const styles = {
    simpleLink: "bg-transparent appearance-none outline-none hover:text-gray-900 px-2 py-1 transition-colors duration-200 text-sm font-medium",
    mobileLinkBase: "block w-full text-left py-3 px-4 hover:bg-gray-50 transition-colors duration-200",
    header: "bg-white border-b",
    contentWrapper: "container mx-auto px-6 py-4 flex items-center",
    menuButton: "lg:hidden text-gray-600 hover:text-gray-900 focus:outline-none"
};

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const handleLinkClick = () => setIsMenuOpen(false);
  const mobileLinkClass = (isActive: boolean) => `${styles.mobileLinkBase} ${isActive ? 'font-bold text-gray-900 bg-gray-50' : 'text-gray-700'}`;

  const MenuIcon = (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      {isMenuOpen ? (
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
      ) : (
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
      )}
    </svg>
  );

  return (
    <header className={styles.header}>
      <div className={styles.contentWrapper}>
        <div className="flex items-center">
          <Link to="/" onClick={handleLinkClick} className="flex items-center bg-transparent appearance-none outline-none">
            <img src={logo} alt="SSA Group" style={{ width: '150px' }} className="w-auto h-auto" loading="lazy" decoding="async" />
          </Link>
        </div>
        <nav className="hidden lg:flex ml-8">
          <ul className="flex items-center text-sm font-medium text-gray-700 space-x-6 list-none p-0">
            {navItems.map((item) => (
              item.dropdown ? (
                <Dropdown key={item.name} name={item.name} pageId={item.pageId} items={item.dropdown} isMobile={false} />
              ) : (
                <li key={item.name}>
                  <NavLink to={item.pageId === 'home' ? '/' : `/${item.pageId}`} onClick={handleLinkClick} className={({ isActive }) => `${styles.simpleLink} ${isActive ? 'text-gray-900 font-semibold' : 'text-gray-700'}`}>
                    {item.name}
                  </NavLink>
                </li>
              )
            ))}
          </ul>
        </nav>
        <div className="flex-grow flex justify-end items-center">
          <button type="button" onClick={() => setIsMenuOpen(!isMenuOpen)} className={styles.menuButton} aria-expanded={isMenuOpen} aria-label="Toggle navigation">
              {MenuIcon}
          </button>
        </div>
      </div>
      {isMenuOpen && (
        <div className="lg:hidden bg-white border-t">
          <ul className="flex flex-col text-gray-700">
            {navItems.map((item) => (
              item.dropdown ? (
                <Dropdown key={item.name} name={item.name} pageId={item.pageId} items={item.dropdown} isMobile={true} />
              ) : (
                <li key={item.name} className="w-full">
                  <NavLink to={item.pageId === 'home' ? '/' : `/${item.pageId}`} onClick={() => { handleLinkClick(); setIsMenuOpen(false); }} className={({ isActive }) => mobileLinkClass(isActive)}>
                    {item.name}
                  </NavLink>
                </li>
              )
            ))}
          </ul>
        </div>
      )}
    </header>
  );
};

export default Header;
